import authRoles from "core/auth/authRoles";
import Register from "./Register";

const RegisterConfig = {
  component: Register,
  path: "/register",
  exact: true,
  layout: {
    config: {
      header: {
        display: false,
      },
      sidebar: {
        display: false,
      },
      footer: {
        display: false,
      },
    },
  },
  protected: false,
  auth: authRoles.anyOne,
};

export default RegisterConfig;
